import "core-js/actual/object/has-own";
import "core-js/actual/array/at";
import "core-js/actual/structured-clone";
import "core-js/actual/string/replace-all";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { RootErrorBoundary } from "@/components/RootErrorBoundary";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

window.__CARIO_BOOTED__ = true;
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RootErrorBoundary><App /></RootErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator && window.isSecureContext) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch((e) => console.warn("Service worker registration failed", e)));
}
